import React from "react";
import "./horoscope-popup.m.css";
import { ResponsiveImage } from "@quintype/components";
const Horoscopes = [
  {
    index: 1,
    icon: "dh-sandbox/2025-09-22/dbskxel5/ariespurple",
    name: "Aries",
    key: "aries"
  },
  {
    index: 2,
    icon: "dh-sandbox/2025-09-22/t70lky3x/tauruspurple",
    name: "Taurus",
    key: "taurus"
  },
  {
    index: 3,
    icon: "dh-sandbox/2025-09-22/ftbetusu/geminipurple",
    name: "Gemini",
    key: "gemini"
  },
  {
    index: 4,
    icon: "dh-sandbox/2025-09-22/0401wb9h/cancerpurple",
    name: "Cancer",
    key: "cancer"
  },
  {
    index: 5,
    icon: "dh-sandbox/2025-09-22/hdzcgfax/leopurple",
    name: "Leo",
    key: "leo"
  },
  {
    index: 6,
    icon: "dh-sandbox/2025-09-22/ma6nk8a6/virgopurple",
    name: "Virgo",
    key: "virgo"
  },
  {
    index: 7,
    icon: "dh-sandbox/2025-09-22/28uddiq8/librapurple",
    name: "Libra",
    key: "libra"
  },
  {
    index: 8,
    icon: "dh-sandbox/2025-09-22/6lgrv8sm/scorpiopurple",
    name: "Scorpio",
    key: "scorpio"
  },
  {
    index: 9,
    icon: "dh-sandbox/2025-09-22/gez3qxoa/sagittariuspurple",
    name: "Sagittarius",
    key: "sagittarius"
  },
  {
    index: 10,
    icon: "dh-sandbox/2025-09-22/ldifc22t/capricornpurple",
    name: "Capricorn",
    key: "capricorn"
  },
  {
    index: 11,
    icon: "dh-sandbox/2025-09-22/taq61sts/aquariuspurple",
    name: "Aquarius",
    key: "aquarius"
  },
  {
    index: 12,
    icon: "dh-sandbox/2025-09-22/imct4cuc/piscespurple",
    name: "Pisces",
    key: "pisces"
  }
];
const HoroscopePopup = ({ scrollToZodiac }) => {
  const zodiacClickHandler = (e, id) => {
    e.stopPropagation();
    console.log("CLICKED");
    const offset = 150;
    scrollToZodiac(id, offset);
  };
  return (
    <div styleName="wrapper">
      {Horoscopes.map((item) => (
        <div key={item.index} onClick={(e) => zodiacClickHandler(e, item.index)} styleName="zodiac-card">
          <ResponsiveImage slug={item.icon} widths={[20]} />
          <span>{item.name}</span>
        </div>
      ))}
    </div>
  );
};

export default HoroscopePopup;
